<template>
	<div class="cc v2_rsv noselect">
		<div v-if="isLoading" class="loading_bg fixed" style="z-index: 999;">
			<div class="loading_wrap">
				<div class="loading_obj">
					<svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66"
						xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30">
						</circle>
					</svg>
				</div>
			</div>
		</div>
		<LeftPannel />
		<div class="content_wrap">
			<TopFilter @showSettingPopup="showSettingPopup" />
			<Sheet :isShowSettingPopup="isShowSettingPopup" @hideSettingPopup="hideSettingPopup" />
		</div>
	</div>
</template>


<script>
import { mapActions, mapState } from "vuex";

const moment = require("@/util/MPMoment");

import LeftPannel from "./Components/LeftPannel/ReservationLeftPannel.vue";
import TopFilter from "./Components/TopFilter/ReservationTopFilter.vue";
import Sheet from "./Components/Sheet/ReservationSheet.vue";

import { closeAlertPopup } from './sheet-alert'
import { sheetState } from './sheet-state'
import { closePopup } from './sheet-overlays'
import { exitTimeSelectMode, setSelectedReservation } from './reservation-selection'
import { setSelectedDate } from './sheet-axis'
import { workerState, reInit } from './Components/Popups/WorkStatePopup/worker-state'
import { useQueryClient } from "@tanstack/vue-query";
import { usePushQueryInvalidation } from "@/composables/use-push-query-invalidation";
import { isApiErrorWithCode } from "@/apis/instances/check-api-response";
import { v2ReservationSettingFindOneQueryOptions } from "@/composables/queries/v2reservationsetting/use-v2-reservationsetting-find-one-query";
import { v2ReservationListQueryOptions } from "@/composables/queries/v2reservation/use-v2-reservation-list-query";
import { serviceSettingCountriesQueryOptions } from "@/composables/queries/servicesetting/use-service-setting-countries-query";

export default {
	setup() {
		const queryClient = useQueryClient();
		// FCM 푸시(타 사용자 변경) → 설정성 도메인 쿼리 캐시 무효화
		usePushQueryInvalidation();
		return { queryClient };
	},
	components: { LeftPannel, TopFilter, Sheet },
	data() {
		return {
			sheetState,
			worker: workerState,
			isShowSettingPopup: false,
		};
	},
	watch: {
		"remote_notification.d_v2ReservationSettingUpdate_el": {
			deep: true,
			handler: function (newValue) {
				if (newValue?.data?.hospitalID == this.hospital.selectedHospital._id) {
					this.loadReservationSetting();
				}
			},
		},
		"$route.query": {
			immediate: true,
			handler: function (newValue) {
				if (newValue.reservationID != undefined) {
					this.moveToReservation(newValue.reservationID);
					delete this.$route.query.reservationID;
				}
			},
		},
	},
	computed: {
		...mapState(["SaaS"]),

		isLoading: function () {
			return this.sheetState.isSheetLoading;
		},
		isWindow: function () {
			return this.SaaS.isWindow ?? false;
		},
	},
	mounted() {
		this.loadReservationSetting();
		this.initWDataController();

		if (this.isWindow == true) {
			this.loadCountryList();
		}
	},
	destroyed() {
		closePopup();
		closeAlertPopup();
		exitTimeSelectMode();
	},
	methods: {
		...mapActions(["AC_CountryList"]),

		showSettingPopup() {
			this.isShowSettingPopup = true;
		},
		hideSettingPopup() {
			this.isShowSettingPopup = false;
		},
		async loadReservationSetting() {
			let hospitalID = this.hospital.selectedHospital._id;
			let model = {
				hospitalID: hospitalID,
			};
			try {
				this.sheetState.reservationSetting = await this.queryClient.fetchQuery(v2ReservationSettingFindOneQueryOptions(model));
			} catch (err) {
				// 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
				if (!isApiErrorWithCode(err)) throw err;
				console.log(err);
			}
		},

		async loadCountryList() {
			const model = {
				hospitalID: this.hospital.selectedHospital._id,
				limit: 240,
			};
			let countries;
			try {
				countries = await this.queryClient.fetchQuery(serviceSettingCountriesQueryOptions(model));
			} catch (err) {
				// 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
				if (!isApiErrorWithCode(err)) throw err;
				console.log(err);
				return;
			}
			await this.AC_CountryList(countries);
		},

		initWDataController() {
			reInit();
		},

		async moveToReservation(reservationID) {
			if (reservationID == undefined) {
				return;
			}
			let hospitalID = this.hospital.selectedHospital._id;
			let filter = {
				hospitalID: hospitalID,
				_id: reservationID,
				isRemoved: false,
			};
			let reservations;
			try {
				reservations = await this.queryClient.fetchQuery(v2ReservationListQueryOptions(filter));
			} catch (err) {
				// 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
				if (!isApiErrorWithCode(err)) throw err;
				console.log(err);
				return;
			}
			setSelectedDate(moment(
				reservations?.[0]?.startedAt,
			).startOf("days"));
			setSelectedReservation(reservations?.[0])
		},
	},
};
</script>


<style scoped>
@import './CSS/V2ReservationManagement.css';

*.noselect {
	-webkit-touch-callout: none;
	/* iOS Safari */
	-webkit-user-select: none;
	/* Safari */
	-khtml-user-select: none;
	/* Konqueror HTML */
	-moz-user-select: none;
	/* Old versions of Firefox */
	-ms-user-select: none;
	/* Internet Explorer/Edge */
	user-select: none;
	/* Non-prefixed version, currently
                                     supported by Chrome, Edge, Opera and Firefox */
}
</style>